import { useState } from 'react';
import api from '../../../../../services/api';
import { formatErrorDetail } from '../utils/helperUtils';

/**
 * Hook to manage AI-driven content improvement features
 */
export const useAIFeatures = (rfpId, editableData, activeSection, selectedCell, handleSidePanelEdit, setUpdateStatus) => {
    const [isRefining, setIsRefining] = useState(false);
    const [aiPrompt, setAiPrompt] = useState('');

    const handleAIImprove = async () => {
        if (!aiPrompt) return;

        let contentToRefine = "";
        if (selectedCell) {
            contentToRefine = selectedCell.value;
        } else {
            const sectionData = editableData[activeSection];
            contentToRefine = typeof sectionData === 'string'
                ? sectionData
                : (Array.isArray(sectionData) ? sectionData.join('\n\n') : JSON.stringify(sectionData));
        }

        if (!contentToRefine) return;

        setIsRefining(true);
        setUpdateStatus(null);

        try {
            const sectionData = editableData[activeSection];
            const sectionId = (sectionData && typeof sectionData === 'object' && sectionData.id) ? sectionData.id : activeSection;

            const response = await api.post('/rfp/refine-section', {
                rfp_id: rfpId,
                id: sectionId,
                current_content: contentToRefine,
                refinement_prompt: aiPrompt
            });

            const data = response.data;

            if (response.status === 200) {
                // Backend returns HTML directly — pass it straight to the editor
                handleSidePanelEdit(data.refined_content);
                setAiPrompt('');
                setUpdateStatus({ type: 'success', message: data.message || 'Content refined by AI!' });
            } else {
                setUpdateStatus({ type: 'error', message: formatErrorDetail(data.detail) || 'AI refinement failed.' });
            }
        } catch (err) {
            setUpdateStatus({ type: 'error', message: 'Network error. Please try again.' });
        } finally {
            setIsRefining(false);
            setTimeout(() => setUpdateStatus(null), 3000);
        }
    };

    return {
        isRefining,
        aiPrompt,
        setAiPrompt,
        handleAIImprove
    };
};
